"use client";

import {
  Button,
  Center,
  H3,
  Modal,
  Stack,
  Text,
} from "@/components/ui/elements";
import { AttentionIcon } from "@/components/ui/elements/icon";

type ReRegistrationConfirmModalProps = {
  opened: boolean;
  /** 閉じる・キャンセル押下時。ログイン制限は解除されず、認証へも進まない */
  onClose: () => void;
  /** 再登録の承認時。認証へ進む */
  onApprove: () => void;
  /** 承認後の通信中 */
  loading?: boolean;
};

/**
 * 自主退会した電話番号での再ログイン時に表示する確認ダイアログ。
 * 承認すると認証へ進み、認証成功時にログイン制限が自動解除される。
 */
export function ReRegistrationConfirmModal({
  opened,
  onClose,
  onApprove,
  loading = false,
}: ReRegistrationConfirmModalProps) {
  return (
    <Modal
      opened={opened}
      close={onClose}
      centered
      size="md"
      padding="sm"
      withCloseButton={false}
      radius="lg"
      // 枠外クリックやEscでは閉じない（LINEログインでは閉じるとポップアップごと終わるため）
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <Stack gap="lg" pb="lg">
        <Stack gap="md" align="center">
          <Center
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              backgroundColor: "var(--mantine-color-blue-0)",
              border: "1px solid var(--mantine-color-blue-2)",
            }}
          >
            <AttentionIcon size="32px" color="var(--mantine-color-blue-6)" />
          </Center>
          <H3 ta="center" c="blue.9">
            以前退会された電話番号です。再登録しますか
          </H3>
          <Text size="sm" ta="center" lh={1.6}>
            再登録すると、退会前に登録されていたプロフィールや勤務の実績を引き継いでご利用いただけます。
          </Text>
        </Stack>

        <Stack gap="xs">
          <Button
            color="blue"
            onClick={onApprove}
            variant="filled"
            fullWidth
            size="md"
            loading={loading}
          >
            再登録する
          </Button>
          <Button
            color="gray"
            onClick={onClose}
            variant="light"
            fullWidth
            size="md"
            disabled={loading}
          >
            閉じる
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
}
